import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * Like2Fit-themed sonner wrapper.
 * Default toasts use cream surface + serif title; success/error variants
 * map to the existing l2f-toast-* tokens (sage / coral).
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      position="top-center"
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            "group toast !rounded-2xl !border-[0.5px] !border-black/10 !bg-[#FAECE7] !text-[#0A0A0A] !shadow-[0_10px_30px_-10px_rgba(10,10,10,0.18)] !px-4 !py-3",
          title: "!font-medium !text-[14px]",
          description: "!text-[12px] !text-[#0A0A0A]/65",
          actionButton:
            "!bg-[#FF5C5C] !text-white !rounded-full !px-3 !py-1.5 !text-[12px] !font-medium",
          cancelButton:
            "!bg-transparent !text-[#0A0A0A]/65 !rounded-full !px-3 !py-1.5 !text-[12px]",
          success:
            "!bg-[#EAF3DE] !text-[#27500A] !border-[#97C459]",
          error:
            "!bg-[#FAECE7] !text-[#712B13] !border-[#F5C4B3]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
